// extracted by mini-css-extract-plugin
export default {"filter":"ElectionFilterCheckbox_filter__8Yg19","filter_title":"ElectionFilterCheckbox_filter_title__39ofC","checkbox":"ElectionFilterCheckbox_checkbox__EIwYd"};